module.exports = __webpack_public_path__ + "media/images/partner/easy-dfaa75b64c679dad14016bbc26b53633.jpg";